import {CommonMessages} from '../common.messages';

export const PanelAccountsEditDetailsMessages = {
    GetClearingAgentsFailed: {
        key: 'GetClearingAgentsFailed',
        message: 'Error while communication with the server. Unable to get all available clearing agents.'
    },
    GetClearingAgentsNotFound: {
        key: 'GetClearingAgentsNotFound',
        message: 'Error while communication with the server. Unable to find all available clearing agents.'
    },
    GetTradingPlatformsFailed: {
        key: 'GetTradingPlatformsFailed',
        message: 'Error while communication with the server. Unable to get available client trading platforms.'
    },
    GetTradingPlatformsNotFound: {
        key: 'GetTradingPlatformsNotFound',
        message: 'Error while communication with the server. Unable to find available client trading platforms.'
    },
    UpdateTradingAccountFailed: {
        key: 'UpdateTradingAccountFailed',
        message: 'Error while request to the server. Unable to update account details.'
    },
    BadAccountReferenceId: {
        key: 'BadAccountReferenceId',
        message: 'Account reference id is not suitable for the desired trading platform.'
    },
    GetBrokersFailed: {
        key: 'GetBrokersFailed',
        message: 'Error while request to the server. Unable to get brokers.'
    },
    GetBrokersNotFound: {
        key: 'GetBrokersNotFound',
        message: 'Error while request to the server. Brokers not found.'
    },
    ...CommonMessages
};
